const dataExample = [
  {
    id: 'css',
    label: 'css',
    value: 596,
  },
  {
    id: 'php',
    label: 'php',
    value: 363,
  },
  {
    id: 'go',
    label: 'go',
    value: 318,
  },
  {
    id: 'c',
    label: 'c',
    value: 285,
  },
  {
    id: 'sass',
    label: 'sass',
    value: 397,
  },
];

export default dataExample;
